import React, {Component} from 'react';
import zxcvbn from 'zxcvbn';
import {withFormsy} from "formsy-react";

class PasswordField extends Component {

    static MinStrength = 2;
    static MinLength = 8;
    static MaxLength = 16;

    static passwordRules = [
        {
            regex: /(?=.*[A-Z])/,
            description: 'Should contain at least 1 uppercase alphabetical character'
        },
        {
            regex: /(?=.*[a-z])/,
            description: 'Should contain at least 1 lowercase alphabetical character'
        },
        {
            regex: /(?=.*[0-9])/,
            description: 'Should contain at least 1 numeric character'
        },
        {
            regex: /(?=.[!@#$%^&])/,
            description: 'Should contain at least one of these special characters, !@#$%^&'
        },
        {
            regex: /(?=.{8,})/,
            description: `Must be ${PasswordField.MinLength} characters or longer`
        },
    ]

    constructor(props) {
        super(props);

        this.state = {
            id: this.getId(props),
            strength: 0
        };
    }

    getId(props) {
        let _a = props, id = _a.id, label = _a.label, name = _a.name;
        if (id !== '') {
            return id;
        }
        let inString = JSON.stringify(label), hash = 0;

        for (let i = 0; i < inString.length; i += 1) {
            hash = ((hash << 5) - hash + inString.charCodeAt(i)) & 0xffffffff;
        }
        return [
            'frc',
            name.split('[').join('_').replace(']', ''),
            hash,
        ].join('-');
    }
    onPasswordChanged = event => {
        const value = event.target.value;
        const strength = zxcvbn(value).score;

        this.setState({
            strength
        }, () => this.props.setValue(value));
    };

    static validatePasswordStrong = (value) => {
        let score = zxcvbn(value).score;
        let color = "";
        switch (score) {
            case 0:
                color = "darkred";
                break;
            case 1:
                color = "orangered";
                break;
            case 2:
                color = "orange";
                break;
            case 3:
                color = "yellowgreen";
                break;
            case 4:
                color = "green";
                break;
        }
        switch (score) {
            case 0:
                return (
                    <span style={{color}}>Too Weak</span>
                )
            case 1:
                return (
                    <span style={{color}}>Weak</span>
                )
            case 2:
                return (
                    <span style={{color}}>Okay</span>
                )
            case 3:
                return (
                    <span style={{color}}>Good</span>
                )
            case 4:
                return (
                    <span style={{color}}>Strong</span>
                )
            case 5:
                return (
                    <span style={{color}}>Very Strong</span>
                )
        }
    };

    render() {

        const {
            getValue,
            getErrorMessage,
            showRequired,
            isFormSubmitted,
            isValid,
            required,
            label,
            placeholder,
            ...restProps
        } = this.props;

        const password = getValue() || '';
        const errorMessage = isFormSubmitted() && getErrorMessage();
        let className = showRequired() ? 'required ' : '';

        className += !isValid() && isFormSubmitted() ? 'text-danger' : '';
        let inputClassName = !isValid() && isFormSubmitted() ? 'is-invalid' : '';


        const {strength} = this.state;

        const passwordLength = password.length;
        const passwordStrong = strength >= PasswordField.MinStrength;
        const passwordLong = passwordLength > PasswordField.MinLength;

        const counterClass = ['badge badge-pill', passwordLong ? passwordStrong ? 'badge-success' : 'badge-warning' : 'badge-danger'].join(' ')
            .trim();

        const strengthClass = ['strength-meter mt-2', passwordLength > 0 ? 'visible' : ' empty'].join(' ').trim();


        return (
            <div className="flex flex-col items-stretch position-relative">
                <div className={'form-group ' + className}>
                    <label className="col-form-label" data-required={required} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>
                            {label}
                            {required && <span className="required-symbol"> *</span>}
                        </span>

                        {password && password.length > 0 && (
                            <span className="ml-1">{PasswordField.validatePasswordStrong(password)}</span>
                        )}
                    </label>


                        <input
                            autoComplete={'new-password'}
                            className={"form-control " + inputClassName}
                            type="password"
                            placeholder={placeholder || '********'}
                            onChange={this.onPasswordChanged}
                            value={password}
                            required={required}
                            name={this.props.name}
                            disabled={this.props.disabled}
                            id={this.state.formId}
                        />
                    <div className="position-relative ">
                        <div className={strengthClass}>
                            <div className="strength-meter-fill" data-strength={strength}/>
                        </div>
                        <div className="form-hint mt-2">
                            You are required to use a sufficiently strong password.
                            {/* {password && password.length > 0 && (
                                <span className="ml-1">{PasswordField.validatePasswordStrong(password)}</span>
                            )} */}


                            {/*<ul className="list-unstyled pl-3 mt-1">*/}
                            {/*    {PasswordField.passwordRules.map((rule, index) => {*/}
                            {/*        let valid = rule.regex.test(password)*/}

                            {/*        return (*/}
                            {/*            <li key={"rule-" + index} className={valid ? 'text-success' : ''}>*/}
                            {/*                {valid ? <i className="fa fa-check"/> : '-'}*/}
                            {/*                <span className="ml-1">*/}
                            {/*                     {rule.description}*/}
                            {/*                 </span>*/}
                            {/*            </li>*/}
                            {/*        )*/}
                            {/*    })}*/}
                            {/*</ul>*/}
                        </div>

                    </div>
                    {errorMessage && (
                        <div className="invalid-feedback">
                            <div>{errorMessage}</div>
                        </div>
                    )}
                </div>



            </div>
        );
    }

}

export default withFormsy(PasswordField);